import { render, staticRenderFns } from "./DeliveryTaskCreateModal.vue?vue&type=template&id=1848b47a&scoped=true"
import script from "./DeliveryTaskCreateModal.vue?vue&type=script&lang=js"
export * from "./DeliveryTaskCreateModal.vue?vue&type=script&lang=js"
import style0 from "./DeliveryTaskCreateModal.vue?vue&type=style&index=0&id=1848b47a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1848b47a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1848b47a')) {
      api.createRecord('1848b47a', component.options)
    } else {
      api.reload('1848b47a', component.options)
    }
    module.hot.accept("./DeliveryTaskCreateModal.vue?vue&type=template&id=1848b47a&scoped=true", function () {
      api.rerender('1848b47a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/order-receive/delivery/DeliveryTaskCreateModal.vue"
export default component.exports